// Rilevazione dell'ambiente di esecuzione. Il ramo browser vince su Node:
// sotto jsdom (test) esistono sia `window` sia `process`, e il comportamento
// corretto è quello browser.

/// `true` in un ambiente browser (o browser-like, es. jsdom).
export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

/// `true` in Node.js puro (senza DOM).
export function isNode(): boolean {
  return (
    !isBrowser() &&
    typeof process !== 'undefined' &&
    typeof process.versions?.node === 'string'
  )
}

/// `contexts.runtime` dell'evento: `{name:'browser'}` oppure
/// `{name:'node', version: process.version}`.
export function runtimeContext(): Record<string, unknown> {
  if (isNode()) return { name: 'node', version: process.version }
  return { name: 'browser' }
}
